// add new trackingInfo to cart
exports.addToCart = (
  trackingInfo = {
    name: 'Desconhecido',
    id: 0,
    price: 0,
    category: 'Desconhecido',
    quantity: 1,
    variant: 'Desconhecido'
  }
) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    // if( trackingInfo.qty == 0) { return removeToCart.apply(trackingInfo) };

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: 'BRL',
        add: {
          products: [
            {
              name: trackingInfo.name,
              id: trackingInfo.id,
              price: trackingInfo.price,
              category: trackingInfo.category,
              quantity: trackingInfo.quantity,
              variant: trackingInfo.variant
            }
          ]
        }
      }
    });
  }
};

// view trackingInfo detail
exports.removeFromCart = (
  trackingInfo = {
    name: 'Desconhecido',
    id: 0,
    price: 0,
    category: 'Desconhecido',
    variant: 'Desconhecido',
    quantity: 1
  }
) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        detail: {
          products: [
            {
              name: trackingInfo.name,
              id: trackingInfo.id,
              price: trackingInfo.price,
              category: trackingInfo.category,
              variant: trackingInfo.variant,
              quantity: trackingInfo.quantity
            }
          ]
        }
      }
    });
  }
};

exports.clearCart = (products = []) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        detail: {
          products
        }
      }
    });
  }
};

exports.onCheckout = (products = [], step, option = '') => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: { step, option },
          products
        }
      }
    });
  }
};

exports.onPaymentConfirmation = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: { step: 'payment-confirmation' }
        }
      }
    });
  }
};

// view trackingInfo detail - Bolão
exports.viewGameLottery = (
  trackingInfo = {
    name: 'Desconhecido',
    id: 0,
    price: 0,
    category: 'Desconhecido',
    variant: 'Desconhecido'
  }
) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'detail',
      ecommerce: {
        detail: {
          products: [
            {
              name: trackingInfo.name,
              id: trackingInfo.id,
              price: trackingInfo.price,
              category: trackingInfo.category,
              variant: trackingInfo.variant
            }
          ]
        }
      }
    });
  }
};

// view trackingInfo detail - Seu jogo
exports.viewGameLotteryMSJ = (
  trackingInfo = {
    name: 'Desconhecido',
    id: 0,
    price: 0,
    category: 'Desconhecido',
    variant: 'Desconhecido'
  }
) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;

    dataLayer.push({ ecommerce: null });

    dataLayer.push({
      event: 'detailMSJ',
      ecommerce: {
        detail: {
          products: [
            {
              name: trackingInfo.name,
              id: trackingInfo.id,
              price: trackingInfo.price,
              category: trackingInfo.category,
              variant: trackingInfo.variant
            }
          ]
        }
      }
    });
  }
};
